import { Typography } from "@material-ui/core";
import { FC, ReactNode } from "react";

import useStyles from "./AlertIcon.styles";


export interface AlertIconProps {
    icon: ReactNode;
    title: string;
    subTitle?: string;
}

const AlertIcon: FC<AlertIconProps> = ({ icon, title, subTitle }) => {
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <div className={classes.icon}>
                {icon}
            </div>
            <div className={classes.textContainer}>
                <Typography className={classes.title} variant="body1" align="left">{title}</Typography>
                {subTitle && <Typography className={classes.subTitle} variant="body1" align="left">{subTitle}</Typography>}
            </div>
        </div>
    );
};

export default AlertIcon;
